import { render, staticRenderFns } from "./template-table.vue?vue&type=template&id=448135e4&scoped=true"
import script from "./template-table.vue?vue&type=script&lang=js"
export * from "./template-table.vue?vue&type=script&lang=js"
import style0 from "./template-table.vue?vue&type=style&index=0&id=448135e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448135e4",
  null
  
)

export default component.exports